import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import axios from 'axios';
import Header from '../components/Header';
import Footer from '../components/Footer';
import WhatsAppButton from '../components/WhatsAppButton';
import { Calendar, User, ArrowRight } from 'lucide-react';

const BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || '').trim();
const API = BACKEND_URL ? `${BACKEND_URL}/api` : null;

export default function Blog() {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchBlogs();
  }, []);

  const fetchBlogs = async () => {
    try {
      if (!API) {
        setBlogs([
          {
            id: '1',
            title: 'Digital Skills – Future of Career',
            content: 'आज के डिजिटल युग में इंटरनेट और सोशल मीडिया करियर बनाने का सबसे बड़ा माध्यम बन चुका है। जो लोग डिजिटल स्किल्स सीख लेते हैं वे घर बैठे भी ऑनलाइन काम करके अच्छी आय प्राप्त कर सकते हैं। Manish Kasyap Digital Research Platform का उद्देश्य युवाओं और महिलाओं को डिजिटल शिक्षा देकर उन्हें आत्मनिर्भर बनाना है।',
            author: 'Manish Kasyap',
            created_at: new Date().toISOString()
          },
          {
            id: '2',
            title: 'सोशल मीडिया से कमाई कैसे करें?',
            content: 'सोशल मीडिया आज के समय में सबसे बड़ा प्लेटफॉर्म बन चुका है। YouTube, Instagram, Facebook जैसे प्लेटफॉर्म्स पर आप अपना कंटेंट शेयर करके लाखों लोगों तक पहुंच सकते हैं और अच्छी कमाई कर सकते हैं।',
            author: 'MKDRP Team',
            created_at: new Date(Date.now() - 86400000).toISOString()
          }
        ]);
        return;
      }

      const response = await axios.get(`${API}/blog`);
      setBlogs(response.data);
    } catch (error) {
      console.error('Error fetching blogs:', error);
      setBlogs([
        {
          id: '1',
          title: 'Digital Skills – Future of Career',
          content: 'आज के डिजिटल युग में इंटरनेट और सोशल मीडिया करियर बनाने का सबसे बड़ा माध्यम बन चुका है। जो लोग डिजिटल स्किल्स सीख लेते हैं वे घर बैठे भी ऑनलाइन काम करके अच्छी आय प्राप्त कर सकते हैं। Manish Kasyap Digital Research Platform का उद्देश्य युवाओं और महिलाओं को डिजिटल शिक्षा देकर उन्हें आत्मनिर्भर बनाना है।',
          author: 'Manish Kasyap',
          created_at: new Date().toISOString()
        },
        {
          id: '2',
          title: 'सोशल मीडिया से कमाई कैसे करें?',
          content: 'सोशल मीडिया आज के समय में सबसे बड़ा प्लेटफॉर्म बन चुका है। YouTube, Instagram, Facebook जैसे प्लेटफॉर्म्स पर आप अपना कंटेंट शेयर करके लाखों लोगों तक पहुंच सकते हैं और अच्छी कमाई कर सकते हैं।',
          author: 'MKDRP Team',
          created_at: new Date(Date.now() - 86400000).toISOString()
        }
      ]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <WhatsAppButton />

      <section className="bg-gradient-to-br from-orange-500 to-red-600 text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.h1 
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-5xl md:text-6xl font-extrabold font-heading mb-6"
            data-testid="blog-title"
          >
            Blog & Updates
          </motion.h1>
          <motion.p 
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.2 }}
            className="text-xl font-hindi"
          >
            डिजिटल दुनिया की नवीनतम जानकारी
          </motion.p>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {loading ? (
            <div className="text-center py-12">
              <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-orange-500"></div>
            </div>
          ) : (
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {blogs.map((blog, index) => (
                <motion.article
                  key={blog.id}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.1 }}
                  className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100 flex flex-col"
                  data-testid={`blog-card-${index}`}
                >
                  <div className="bg-gradient-to-br from-orange-400 to-red-500 h-48 flex items-center justify-center text-white">
                    <h3 className="text-2xl font-bold font-heading px-6 text-center">
                      {blog.title}
                    </h3>
                  </div>
                  <div className="p-6 flex-1 flex flex-col">
                    <div className="flex items-center gap-4 text-sm text-gray-500 mb-4">
                      <div className="flex items-center gap-1">
                        <User className="w-4 h-4" />
                        <span>{blog.author}</span>
                      </div>
                      <div className="flex items-center gap-1">
                        <Calendar className="w-4 h-4" />
                        <span>
                          {new Date(blog.created_at).toLocaleDateString('hi-IN', {
                            day: 'numeric',
                            month: 'short',
                            year: 'numeric'
                          })}
                        </span>
                      </div>
                    </div>
                    <p className="text-gray-600 mb-4 font-hindi line-clamp-4 flex-1">
                      {blog.content}
                    </p>
                    <Link 
                      to={`/blog/${blog.id}`}
                      className="inline-flex items-center gap-2 text-orange-600 hover:text-orange-700 font-semibold group"
                    >
                      Read More
                      <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                    </Link>
                  </div>
                </motion.article>
              ))}
            </div>
          )}
        </div>
      </section>

      <Footer />
    </div>
  );
}
